import { Injectable } from '@angular/core';
import * as pdfjsLib from 'pdfjs-dist';

// Set up PDF.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.4.120/pdf.worker.min.js`;

@Injectable({
  providedIn: 'root'
})
export class PdfCheckService {

  constructor() { }

  /**
   * Check if a PDF is (1) not encrypted, (2) encrypted but no password is required,
   * or (3) password protected.
   */
  async checkPdf(arrayBuffer: ArrayBuffer): Promise<'not-encrypted' | 'encrypted-no-password' | 'password-protected'> {
    try {
      // Try loading with empty password
      const loadingTask = pdfjsLib.getDocument({
        data: arrayBuffer,
        password: ''
      });
      
      const pdf = await loadingTask.promise;
      
      // Check for encryption by examining raw PDF content
      const text = new TextDecoder("latin1").decode(arrayBuffer);
      const hasEncryptDict = text.includes('/Encrypt');
      
      if (hasEncryptDict) {
        return 'encrypted-no-password';
      } else {
        return 'not-encrypted';
      }
      
    } catch (error: any) {
      // Check if it's a password exception
      if (error.name === 'PasswordException' || 
          error.message?.toLowerCase().includes('password') ||
          error.message?.toLowerCase().includes('encrypted')) {
        return 'password-protected';
      }
      
      // Rethrow unexpected errors
      throw error;
    }
  }

  /**
   * Helper method to check if file is a PDF
   */
  isPdfFile(file: File): boolean {
    return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf');
  }
}
